<template lang="pug">
    v-card.mx-auto.mb-6(
        v-if="validAgent"
        elevation="10"
        shaped
    )
        v-toolbar(
            flat
            rounded
        )
            //- v-icon.mr-sm-4(large)
            //-     template(v-if="conversationGroup.total_participants > 2") mdi-account-group
            //-     template(v-else) mdi-account
            v-toolbar-title
                | {{ agent.user_full_name }}
                br
                .text-body-2
                    template(v-if="hasMoreThanOneTeam")
                        v-tooltip(top)
                            template(v-slot:activator='{ on, attrs }')
                                span(v-bind="attrs" v-on="on" role="text")
                                    | {{ partialTeamNames }}
                            span
                                | {{ fullTeamNames }}

                    template(v-else) {{ partialTeamNames }}

            v-spacer
            .text-right(style="width: 300px;")
                | {{ agent.agent_status_name }}
                br
                strong
                    Timeago(
                        :datetime="agent.agent_created_at"
                        :auto-update="30"
                    )

        v-card-text.pa-0(
            v-if="agent.assigned_campaign_customer_actives && agent.assigned_campaign_customer_actives.length > 0"
        )
            v-divider.mx-4

            v-simple-table.table-x-scroll.pa-md-3(style="width: 100%;")
                template(v-slot:default)
                    thead
                        tr
                            th
                            th Status
                            th Wait Time
                            th Organization
                            th Campaign
                            th Customer
                    tbody
                        AssignedCampaignCustomerActiveRow(
                            v-for='ccActive in agent.assigned_campaign_customer_actives'
                            :key='ccActive.campaign_customer_active_id'
                            :campaign-customer-active="ccActive"
                            :set-current-campaign-customer="setCurrentCampaignCustomer"
                        )

</template>

<script lang="ts">
    import Vue from 'vue';

    // Load components
    import AssignedCampaignCustomerActiveRow from '@/components/dashboards/live/messages/assigned_campaign_customer_active_row.vue';

    export default Vue.extend({
        data() {
            return {
            }
        },
        methods: {
            prepareTeamNames(teamIDs) {

                // Init
                const teamNames = [];

                // Verify team IDs are present
                if (!(teamIDs?.length > 0) || !(this.teams?.length > 0)) {
                    return teamNames;
                }

                // Loop through team IDs and find team names
                for (let i = 0; i < teamIDs.length; i++) {

                    // Init
                    const teamID = teamIDs[i];
                    if (teamID <= 0) {
                        continue;
                    }

                    // Loop through teams
                    for (let j = 0; j < this.teams.length; j++) {

                        // Init
                        const team = this.teams[j];
                        if (!team && !(team.team_id > 0)) {
                            continue;
                        }

                        // Check if team ID matches
                        if (team.team_id !== teamID) {
                            continue;
                        }

                        // Append team name into array
                        teamNames.push(team.name);
                        break;
                    }
                }

                return teamNames;
            },
        },
        computed: {
            fullTeamNames() {

                // Verify team IDs are present
                if (!(this.agent?.team_ids?.length > 0)) {
                    return "---";
                }

                // Build team names
                const names = this.prepareTeamNames(this.agent?.team_ids);
                if (!(names?.length > 0)) {
                    return "---";
                }

                return names.join(", ");
            },
            hasMoreThanOneTeam() {
                return this.agent?.team_ids?.length > 1;
            },
            partialTeamNames() {

                // Verify team IDs are present
                if (!(this.agent?.team_ids?.length > 0)) {
                    return "---";
                }

                // Build team names
                const names = this.prepareTeamNames(this.agent?.team_ids);
                if (!(names?.length > 0)) {
                    return "---";
                }

                return this.hasMoreThanOneTeam ? names[0] + " + " + (names.length - 1) : names[0];
            },
            validAgent() {
                return this.agent?.account_user_id > 0;
            },
        },
        components: {
            AssignedCampaignCustomerActiveRow,
        },
        props: {
            agent: Object,
            setCurrentCampaignCustomer: Function,
        },
    });
</script>

<style lang="scss" scoped>
</style>